import React from 'react';
import BaseTemplate from './BaseTemplate';
import CarTemplate from './CarTemplate';
import DefaultTemplate from './DefaultTemplate';
import TollTemplate from './TollTemplate';
/**
 * 
 * @param type:发票类型 字符串  data 发票数据 onClose 关闭页面回调
 */
const Template = ({type,data,onClose}) => {
    if (type === 'VAT_SPECIAL_INVOICE_MOTORVEHICLE') {
        return <CarTemplate data={data} onClose={onClose}/>;
    } else if ( type === 'VAT_INVOICE_TOLL') { // 通行费
        return <TollTemplate data={data} onClose={onClose}/>;
    } else {
        return <BaseTemplate data={data} onClose={onClose}/>;
    }
};

export default Template;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/components/InvoiceTemplate/index.tsx